import type { CookieOptions } from '#app'
import { jwtDecode } from 'jwt-decode'
import { ACCOUNT_NO, ACCESS_TOKEN, REFRESH_TOKEN } from './const'

/** 設定 Cookie */
export function setCookie(
  name: string,
  value: any,
  options?: CookieOptions & { readonly?: false }
) {
  useCookie(name, { path: '/', ...options }).value = value
}

/** 將 Access Token 寫入 cookies 內 */
export function setAccessTokenCookie(token: any) {
  const expires = new Date((jwtDecode(token).exp ?? 0 - 10) * 1000)
  setCookie(ACCESS_TOKEN, token, { expires })
}

/** 將 Refresh Token 寫入 cookies 內 */
export function setRefreshTokenCookie(token: any) {
  const expires = new Date((jwtDecode(token).exp ?? 0 - 10) * 1000)

  setCookie(REFRESH_TOKEN, token, { expires })
}

/** 將 Account 寫入 cookies 內 */
export function setAccountNoCookie(value: any) {
  const expires = new Date(new Date().getTime() + 3600 * 1000)
  setCookie(ACCOUNT_NO, value, { expires })
}
